module.exports = __webpack_public_path__ + "img/ic_close.114a02bd.svg";